import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { BroadcastingsService } from 'src/app/services/broadcastings-services/broadcastings.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { EMPTY } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-broadcastings-dashboard',
  templateUrl: './broadcastings-dashboard.component.html',
  styleUrls: ['./broadcastings-dashboard.component.scss']
})
export class BroadcastingsDashboardComponent implements OnInit, OnDestroy {

  broadcastingsCounter;
  tvFormatDevicesCounter;
  getBroadcastingsCountsSubscription: Subscription;
  getTvFormatDevicesSubscription: Subscription;

  constructor(private broadcastingsService: BroadcastingsService,
    private snackbarService: SnackBarService,
    private headerBreadcrumbService: HeaderBreadcrumbService) {}

  ngOnInit() {
    this.setBreadcrumb();
    this.getBroadcastings();
    this.getTvFormatDevices();
  }

  public getBroadcastings() {
    this.getBroadcastingsCountsSubscription = this.broadcastingsService.getBroadcastingsCounts().pipe(
      tap(o => this.broadcastingsCounter = o),
      catchError(error => { this.broadcastingsCounter = '-'; this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public getTvFormatDevices() {
    this.getTvFormatDevicesSubscription = this.broadcastingsService.getTvFormatDevicesCounts().pipe(
      tap(o => this.tvFormatDevicesCounter = o),
      catchError(error => { console.dir(error); this.tvFormatDevicesCounter = '-'; this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fab fa-chromecast', 'broadcastings-page.broadcastings'));
  }

  ngOnDestroy() {
    if (this.getTvFormatDevicesSubscription) { this.getTvFormatDevicesSubscription.unsubscribe(); }
    if (this.getBroadcastingsCountsSubscription) { this.getBroadcastingsCountsSubscription.unsubscribe(); }
  }

}
